// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b27d29b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/mainindex/IndexPc.vue
// module id = 711
// module chunks = 0